export class StargateClient {
  constructor(baseUrl) {
    this.baseUrl = baseUrl || '/gateway/api';
  }
  async fetchToken(clientId) {
    return (await fetch(`${this.baseUrl}/media/auth/smartedge`, {
      credentials: 'include',
      headers: {
        'x-client-id': clientId
      }
    })).json();
  }
  isTokenExpired(token) {
    const currentTimeInSeconds = new Date().getTime() / 1000;
    return token.data.iat + token.data.expiresIn - currentTimeInSeconds < 0;
  }
}